export default {
  "body": "_body_3u88a_10",
  "fullscreenBody": "_fullscreenBody_3u88a_24",
  "topbar": "_topbar_3u88a_27",
  "buttons": "_buttons_3u88a_40",
  "content": "_content_3u88a_46",
  "symbol": "_symbol_3u88a_55",
  "fullscreen": "_fullscreen_3u88a_24"
};import "ni:sha-256;s-5fGEzFyPkjfOfpZYR8gyWnG403nYlom7gOKIMaT5E";